import img_WCS from "../assets/imgFormations/WCS.png";
import img_CFA from "../assets/imgFormations/CFA_Coiffure.png";

const dataFormations = [
  /********** RESTAURATION ***************/
  {
    id: 1,
    image: img_WCS,
    date: "2021 - 2022",
    centre: "Wild Code School",
    lieu: "Nantes",
    statut: "Titre Developpeur Web & Mobile",
  },
  {
    id: 2,
    image: img_CFA,
    date: "2014 - 2016",
    centre: "C.F.A de la coiffure et de l’esthétique ",
    lieu: "Saint-Herblain ",
    statut: "Brevet Professionnel coiffure",
  },
  {
    id: 3,
    image: img_CFA,
    date: "2010 - 2014",
    centre: "C.F.A de la coiffure et de l’esthétique ",
    lieu: "Saint-Herblain ",
    statut: "Certificat d’Aptitude Professionelle coiffure ",
  },
];

export default dataFormations;
